import React from 'react'
import {
  RealEstateDataHeaderData,
  RealEstateDataPage,
  RealEstateDataPageComponentData,
} from 'types'
import Steps from '@components/steps/1'
interface ExternalProps {
  pages: RealEstateDataPage[]
  data: RealEstateDataHeaderData
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const Steps2 = (props: CombinedProps) => {
  return <Steps {...props} />
}

export default Steps2
